import { TableColumnsType } from "antd";
import { DataColumnConfig } from "src/hooks/useTransformDataColumns";
import { Tag } from "src/models/TagModel";
import DeleteModal from "./DeleteModal";
import EditModal from "./EditModal";
import { CLAIMS } from "src/constants";

export type ProductWithActions = Tag & {
  actions?: void;
};

export const config: DataColumnConfig<ProductWithActions> = {
  actions: {
    claims: CLAIMS.EDIT,
  },
};

export const columns: TableColumnsType<Tag & { actions?: void }> = [
  {
    title: "Id",
    key: "id",
    dataIndex: "id",
    ellipsis: true,
  },
  {
    title: "English Name",
    key: "name",
    dataIndex: "name",
    ellipsis: true,
  },
  {
    title: "Arabic Name",
    key: "nameAr",
    dataIndex: "nameAr",
    ellipsis: true,
  },
  {
    title: "Actions",
    key: "actions",
    dataIndex: "actions",
    ellipsis: true,
    fixed: "right",
    className: "bg-white",
    render: (_, record) => (
      <div className="flex gap-2">
        <EditModal record={record} />
        <DeleteModal value={record} />
      </div>
    ),
  },
];
